module.exports = __webpack_public_path__ + "img/background-desktop.5990efb6.png";